import { ICompany } from "src/app/company/models/company";
import { IBase, IBaseSearchRequest } from "src/app/core/models/base";
import { IDeviceCategory } from "./device-category";
import { IDeviceLocation } from "./device-location";
import { IDeviceManufacturer } from "./device-manufacturer";
import { INote } from "./note";
import { IService, IServiceDetailsResponse } from "./service";
import { ImportStatusEnum } from "src/app/history/models/import";
import { IInstallation } from "src/app/installations/models/installation";
import { IWearingPart } from "./wearing-part";

export interface IDevice extends IBase{
    manufacturerId: string,
    type : string,
    serialNumber : string,
    equipmentNumber : string,
    tagNumber : string,
    qrNumber : string,
    sequenceNumber : string,
    importantNote : string,
    company : ICompany,
    deviceCategoryId : string,
    deviceLocationId : string,
    deliveryDate : Date,
    deviceStatus : DeviceStatusEnum,
    devicePriority : DevicePriorityEnum,
    maintenanceInterval : number,
    wearingParts: IWearingPart[]
}

export interface IDeviceDetailsResponse extends IBase{
    id: string,
    type : string,
    serialNumber : string,
    equipmentNumber : string,
    tagNumber : string,
    qrNumber : string,
    sequenceNumber : string,
    importantNote : string,
    manufacturer: IDeviceManufacturer,
    company : ICompany,
    deviceCategory : IDeviceCategory,
    deviceLocation : IDeviceLocation,
    services : IService[],
    deliveryDate : Date,
    deviceStatus : DeviceStatusEnum,
    devicePriority : DevicePriorityEnum,
    maintenanceInterval : number,
    wearingParts: IWearingPart[],
    revisionId : string,
    installation: IInstallation
}

export interface IDeviceReduced extends IBase{
    type : string,
    serialNumber : string,
    equipmentNumber : string,
    tagNumber : string,
    qrNumber : string,
    sequenceNumber : string,
    manufacturer: IDeviceManufacturer,
    deviceStatus : DeviceStatusEnum,
    revisionId? : string,
}

export interface ICreateDeviceRequest {
    manufacturerId: string,
    type : string,
    serialNumber : string,
    equipmentNumber : string,
    tagNumber : string,
    qrNumber : string,
    sequenceNumber : string,
    importantNote : string,
    companyId : string,
    deviceCategoryId : string,
    deviceLocationId : string,
    deliveryDate : Date,
    deviceStatus : DeviceStatusEnum,
    devicePriority : DevicePriorityEnum,
    maintenanceInterval : number,
    revisionId?: string
}

export interface IUpdateDeviceRequest{
    manufacturerId: string,
    id: string,
    type : string,
    serialNumber : string,
    equipmentNumber : string,
    tagNumber : string,
    qrNumber : string,
    sequenceNumber : string,
    importantNote : string,
    companyId : string,
    deviceCategoryId : string,
    deviceLocationId : string,
    deliveryDate : Date,
    deviceStatus : DeviceStatusEnum,
    devicePriority : DevicePriorityEnum,
    maintenanceInterval : number
}

export interface IDeviceMinDto {
    id: string,
    serialNumber: string,
    tagNumber: string,
    type: string,
    manufacturerName: string,
    deviceLocationName: string,
    remark: string,
    importantNote: string,
    services : IServiceDetailsResponse[]
}

export interface ISearchDeviceRequest extends IBaseSearchRequest{
    companyId?: string;
    deviceLocationId?: string;
    deviceManufacturerId?: string;
    deviceCategoryId?: string;
    deviceStatus?: DeviceStatusEnum;
}

export interface IGetDeviceByIdForRevision {
    deviceId: string,
    revisionId: string
}

export interface IImportDevicesRequest {
    file: FormData
}
export interface IImportDevicesResponse {
    importStatus: ImportStatusEnum;
}
export interface IExportDevicesRequest{
    searchRequest: IBaseSearchRequest
}
export interface IExportDevicesResponse{
    file: string;
}




export enum DevicePriorityEnum {
    Unknown = 1,
    Low = 2,
    Medium = 3,
    High = 4
}

export enum DeviceStatusEnum {
    Unknown = 1,
    Draft = 2,
    Approval = 3,
    Active = 4,
    Inactive = 5
}